/* Package JSON Import will be here */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { MenuItem } from '@material-ui/core';
import { bindActionCreators } from 'redux';
/* Package JSON Import will be here */

/* Project Import will be here */
import SecurityPageComponent from './securityPage.Component';
import { ApiUrls } from '../../../services/api';
import Api from '../../../services/api/serviceCall';
import { Constants } from '../../../config/appConstants';
import { MessageBox } from '../../sharedComponent/messageBox';
import * as actions from '../../../actions/login.Action';
/* Package JSON Import will be here */

/* Const,Let & Var will be here */
/* Const,Let & Var will be here */

class SecurityPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userDataList: [],
            filterSecurityData: [],
            selectedEmployeeFullName: [],
            selectedEmployeeNo: [],
            isOpenModel: false,
            userData: {
                employee: [],
                securityGroup: [],
                withSuperAdminSecurityGroup: [],
                group: [],
                division: []
            },
            pagination: {
                activePage: 1,
                totalCount: 0,
                skip: Constants.DEFAULT_SKIP,
                take: Constants.DEFAULT_TAKE
            },
            selectedValue: {},
            existingUserDetails: {},
            isEditUser: false,
            securityUserNameSearchText: "",
            securityEmployeeSearchText: "",
            securityEmployeeNumberSearchText: "",
            securityGroupNameSearchText: "",
            selectedGroup: [],
            selectedDivision: [],
            isshowPasswordClick: false,
            isshowConfirmPassword: false,
            status: [{
                option: "Active", value: 'active'
            }, {
                option: "InActive", value: 'inActive',
            }],
            userStatusOptions: [
                { key: 'Active', text: 'Active', value: 'active' },
                { key: 'Active', text: 'InActive', value: 'inactive' }
            ],
            selectedStatus: 'active',
            isDeActivateConfirmationModalVisible: false,
            isActivateConfirmationModalVisible: false,
            activateOrDeactivateUserId: 0,
            isDisableSaveBtn: false,
        };
    }

    componentDidMount() {
        this.getUserDetailsList();
    }

    getUserDetails(userId) {
        let { selectedValue, selectedGroup, selectedDivision } = this.state;
        let url = `${ApiUrls.Routes.SECU_C}${ApiUrls.Routes.GT_USER_M}?userId=${userId}`;
        Api.Get(url, this).then((responseData) => {
            if (responseData) {
                if (responseData.success) {
                    var division = [];
                    var group = [];
                    responseData.data.user.forEach((a) => {
                        selectedValue.employeeNumber = a.employeeNumber;
                        selectedValue.employeeName = a.employeeName;
                        selectedValue.userName = a.userName;
                        selectedValue.securitygroupID = a.securityGroupId;
                        selectedValue.userId = a.userId;
                        selectedValue.password = a.password;
                        selectedValue.confirmPassword = a.password;
                        selectedValue.status = a.isActive ? 'active' : 'inactive'
                    });
                    selectedDivision = responseData.data.division;
                    selectedDivision.forEach((a) => {
                        division.push(a.divisionName);
                    });
                    selectedGroup = responseData.data.group;
                    if (responseData.data.group.length === 1 && responseData.data.group[0].isAllDivision && responseData.data.group[0].isActive) {
                        group.push("AllDivisions");
                    }
                    else {
                        selectedGroup.map((a) => {
                            if (a.isActive) {
                                group.push(a.divisionId);
                            }
                        });
                    }
                    selectedValue.divisionName = division;
                    selectedValue.groupName = group;
                    selectedValue.isChangePasswordOnly = false;
                    this.setState({
                        selectedValue, existingUserDetails: responseData.data.user[0], isEditUser: true, selectedDivision, selectedGroup
                    });
                }
            }
        });
    }


    handleChange = event => {
        this.setState({
            selectedStatus: event.target.value,
            option: event.target.name,
            pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 },
            securityEmployeeSearchText: "",
            securityUserNameSearchText: "",
            securityEmployeeNumberSearchText: "",
            securityGroupNameSearchText: ""
        }, () => {
            this.getUserDetailsList();
        });
    };

    getUserDetailsList() {
        let { securityUserNameSearchText, securityEmployeeSearchText, securityEmployeeNumberSearchText, securityGroupNameSearchText, pagination, selectedStatus } = this.state;
        let searchArray = [];
        if (securityUserNameSearchText) {
            let searchObj = {
                FieldName: Constants.SECURITY_USERNAME_SEARCH,
                Value: securityUserNameSearchText
            };
            searchArray.push(searchObj);
        };
        if (securityEmployeeSearchText) {
            let searchObj = {
                FieldName: Constants.SECURITY_EMPLOYEE_NAME_SEARCH,
                Value: securityEmployeeSearchText
            };
            searchArray.push(searchObj);
        };
        if (securityEmployeeNumberSearchText) {
            let searchObj = {
                FieldName: Constants.SECURITY_EMPLOYEE_NUMBER_SEARCH,
                Value: securityEmployeeNumberSearchText
            };
            searchArray.push(searchObj);
        };
        if (securityGroupNameSearchText) {
            let searchObj = {
                FieldName: Constants.SECURITY_GROUP_NAME_SEARCH,
                Value: securityGroupNameSearchText
            };
            searchArray.push(searchObj);
        };
        let requestData = {
            SearchText: searchArray,
            Skip: pagination.skip,
            Take: pagination.take
        }
        let url = `${ApiUrls.Routes.SECU_C}${ApiUrls.Routes.GT_A_USR_LT_M}?selectedStatus=${selectedStatus}`;
        Api.Post(url, requestData, this).then((responseData) => {
            if (responseData) {
                if (responseData.success) {
                    pagination.totalCount = Math.ceil(responseData.totalCount / Constants.DEFAULT_TAKE);
                    this.setState({
                        userDataList: responseData.data,
                        pagination
                    });
                }
                else {
                    this.setState({
                        userDataList: []
                    });
                }
            }
        });
    }

    onPageChange = (e, { activePage }) => {
        let { pagination } = this.state;
        pagination.skip = ((activePage - 1) * Constants.DEFAULT_TAKE) + 1;
        pagination.take = ((activePage - 1) * Constants.DEFAULT_TAKE) + Constants.DEFAULT_TAKE;
        pagination.activePage = activePage;
        this.setState({
            pagination
        }, () => {
            this.getUserDetailsList();
        });
    }

    onUserNameSearch = event => {
        this.setState({ securityUserNameSearchText: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
            this.getUserDetailsList();
        });
    }

    onEmployeeNameSearch = event => {
        this.setState({ securityEmployeeSearchText: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
            this.getUserDetailsList();
        });
    }

    onEmployeeNumberSearch = event => {
        this.setState({ securityEmployeeNumberSearchText: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
            this.getUserDetailsList();
        });
    }

    onSecurityGroupSearch = event => {
        this.setState({ securityGroupNameSearchText: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
            this.getUserDetailsList();
        });
    }

    handleFormChange = (e, { name, value }) => {
        let { selectedValue, selectedDivision, selectedGroup } = this.state;
        if (name && value) {
            switch (name) {
                case "groupAccess":
                    selectedValue.securitygroupID = value;
                    if (selectedValue.securitygroupID === 5) {
                        selectedValue.groupName = [];
                    }
                    break;
            }
        }
        this.setState({ selectedValue });
    }

    handleDivisionChange = (e, { name, value }) => {
        let { selectedValue, userData } = this.state;
        if (name && value) {
            let division = value.filter(function (x) {
                return userData.division.some(function (y) {
                    return x == y.value
                })
            });
            switch (name) {
                case "projectLevelAccess":
                    selectedValue.divisionName = division;
                    break;
            }
        }
        this.setState({ selectedValue });
    }

    handleGroupDivisionChange = (e, { name, value }) => {
        let { selectedValue, userData } = this.state;
        if (name && value) {
            let groupDivision = value.filter(function (x) {
                return userData.group.some(function (y) {
                    return x == y.value
                })
            });
            switch (name) {
                case "deviceAccessByGroups":
                    selectedValue.groupName = groupDivision;
                    break;
            }
        }
        this.setState({ selectedValue });
    }

    handleUserNameChange = (e, { value }) => {
        let { selectedValue } = this.state;
        selectedValue.userName = value;
        this.setState({ selectedValue });
    }

    handleEmployeeNumberChange = (e, { value }) => {
        let { selectedValue } = this.state;
        selectedValue.employeeNumber = value.replaceAll(" ", "");
        this.setState({ selectedValue });
    }

    handleEmployeeNameChange = (e, { value }) => {
        let { selectedValue } = this.state;
        selectedValue.employeeName = value.trimStart();
        this.setState({ selectedValue });
    }

    handlePasswordChange = (e, { value }) => {
        let { selectedValue } = this.state;
        selectedValue.password = value;
        this.setState({ selectedValue });
    }

    handleConfirmPasswordChange = (e, { value }) => {
        let { selectedValue } = this.state;
        selectedValue.confirmPassword = value;
        this.setState({ selectedValue });
    }

    handleAddition = (e, { value }) => {
        let { Division } = this.state;
        this.setState((prevState) => ({
            Division: [{ text: value, value }, ...prevState.Division],
        }))
    }

    handleAdditionGroup = (e, { value }) => {
        let { userData } = this.state;
        this.setState((prevState) => ({
            group: [{ text: value, value }, ...prevState.group],
        }))
    }

    handleHideShowPassword() {
        let { isshowPasswordClick } = this.state;
        if (isshowPasswordClick) {
            isshowPasswordClick = false;
        }
        else {
            isshowPasswordClick = true
        }
        this.setState({ isshowPasswordClick });
    }

    handleHideShowConfirmPassword() {
        let { isshowConfirmPassword } = this.state;
        if (isshowConfirmPassword) {
            isshowConfirmPassword = false;
        }
        else {
            isshowConfirmPassword = true
        }
        this.setState({ isshowConfirmPassword });
    }

    onOpenModel = userDetails => {
        this.getAddUserDetails(userDetails);
        this.setState({
            isOpenModel: true, isshowPasswordClick: false, isshowConfirmPassword: false
        });
    }

    getAddUserDetails(userDetails) {
        let { userData, selectedValue } = this.state;
        let url = `${ApiUrls.Routes.SECU_C}${ApiUrls.Routes.GT_ADD_USER_M}`;
        Api.Get(url, this).then((responseData) => {
            if (responseData) {
                if (responseData.success) {
                    responseData.data.securityGroup.length > 0 && responseData.data.securityGroup.map((a) => (
                        userData.withSuperAdminSecurityGroup.push({ key: a.groupID, value: a.groupID, text: a.securityGroupName }),
                        userData.securityGroup.push({ key: a.groupID, value: a.groupID, text: a.securityGroupName })
                    ));

                    userData.securityGroup.splice(userData.securityGroup.findIndex(a => a.text === "SystemAdmin"), 1);

                    userData.group.push({ key: "All Divisions", value: "AllDivisions", text: "All Divisions" });
                    responseData.data.group.length > 0 && responseData.data.group.map((a) => (
                        userData.group.push({ key: a.divisionId, value: a.divisionId, text: a.divisionName })
                    ));

                    if (userData.group.length == 1 && userData.group.find(a => a.value == "AllDivisions")) {
                        userData.group.splice(userData.group.findIndex(a => a.value === "AllDivisions"), 1);
                    }

                    userData.division.push({ key: "All Divisions", value: "AllDivisions", text: "All Divisions" });
                    responseData.data.division.length > 0 && responseData.data.division.map((a) => (
                        userData.division.push({ key: a.divisionName, value: a.divisionName, text: a.divisionName })
                    ));

                    if (userData.division.length == 1 && userData.division.find(a => a.value == "AllDivisions")) {
                        userData.division.splice(userData.division.findIndex(a => a.value === "AllDivisions"), 1);
                    }

                    selectedValue.securitygroupID = userData.securityGroup.find(a => a.text === Constants.ADMIN_ROLE_NAME).value;
                    selectedValue.isChangePasswordOnly = false;
                    selectedValue.status = "active";
                    this.setState({
                        userData,
                        selectedValue
                    }, function () {
                        if (userDetails && userDetails.userId) {
                            this.getUserDetails(userDetails.userId);
                        }
                    });
                }
                else {
                    this.setState({
                        userData
                    });
                }
            }
        });
    }

    onCloseModel = () => {
        let { userData } = this.state;
        userData.employee = [];
        userData.securityGroup = [];
        userData.withSuperAdminSecurityGroup = [];
        userData.group = [];
        userData.division = [];
        this.setState({ isOpenModel: false, isEditUser: false, userData, selectedValue: {} }, () => this.getUserDetailsList());
    }

    onSaveUser(userId = null) {
        let { selectedValue, existingUserDetails, isEditUser, selectedDivision, selectedGroup } = this.state;
        if (selectedValue.employeeNumber === undefined || !selectedValue.employeeNumber) {
            MessageBox(Constants.PLEASE_ENTER_EMPLOYEE_ID, Constants.ERROR);
            return;
        }
        if (selectedValue.employeeName === undefined || !selectedValue.employeeName) {
            MessageBox(Constants.PLEASE_ENTER_EMPLOYEE_NAME, Constants.ERROR);
            return;
        }
        if (!selectedValue.securitygroupID) {
            MessageBox(Constants.PLEASE_SELECT_GROUP_ACCESS, Constants.ERROR);
            return;
        }
        if (selectedValue.userName === undefined || !selectedValue.userName) {
            MessageBox(Constants.PLEASE_ENTER_USER_NAME, Constants.ERROR);
            return;
        }
        if (selectedValue.password === undefined || !selectedValue.password) {
            selectedValue.password = '123456';
            this.setState({ selectedValue });
        }
        if (selectedValue.confirmPassword === undefined || !selectedValue.confirmPassword) {
            selectedValue.confirmPassword = '123456';
            this.setState({ selectedValue });
        }
        if (selectedValue.password != selectedValue.confirmPassword) {
            MessageBox(Constants.PASSWORD_NOT_MATCHED, Constants.ERROR);
            return;
        }
        if (selectedValue.divisionName === undefined || selectedValue.divisionName.length === 0) {
            MessageBox(Constants.PLEASE_SELECT_PROJECT_LEVEL_ACCESS, Constants.ERROR);
            return;
        }
        if (selectedValue.divisionName.length > 1) {
            var isInvalidDivision = selectedValue.divisionName.find(a => a === "AllDivisions");
            if (isInvalidDivision !== undefined) {
                MessageBox(Constants.ALL_DIVISION_INVALID_OPTION, Constants.ERROR);
                return;
            }
        }
        if (selectedValue.securitygroupID !== 5 && (selectedValue.groupName === undefined || selectedValue.groupName.length === 0)) {
            MessageBox(Constants.PLEASE_SELECT_DEVICE_ACCESS_BY_GROUPS, Constants.ERROR);
            return;
        }
        if (selectedValue.groupName.length > 1) {
            var isInvalidDivision = selectedValue.groupName.find(a => a === "AllDivisions");
            if (isInvalidDivision !== undefined) {
                MessageBox(Constants.ALL_DIVISION_DEVICE_ACCESS_BY_GROUPS_INVALID_OPTION, Constants.ERROR);
                return;
            }
        }

        if (selectedValue.userName !== undefined || selectedValue.userName) {
            var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            if (!pattern.test(selectedValue.userName)) {
                MessageBox(Constants.ENTER_VALID_EMAIL, Constants.ERROR);
                return;
            }
        }

        selectedValue.employeeName = selectedValue.employeeName.trimEnd();

        let divisionDetails = [];
        let groupDetails = [];
        let removedDivisionId = [];
        let removedGroupId = [];
        let addedDivisions = [];
        let groupAdded = [];

        if (userId != null) {
            if (existingUserDetails.password != selectedValue.password) {
                selectedValue.isChangePasswordOnly = true;
            }
            selectedValue.userId = userId;
            isEditUser = false;
        }

        selectedValue.divisionName.map((a) => {
            divisionDetails.push({
                DivisionName: a,
            })
        })
        if (userId != null) {
            var divisionIdsRemoved = selectedDivision.filter(a => !divisionDetails.some(b => a.divisionName === b.DivisionName));
            addedDivisions = divisionDetails.filter(a => !selectedDivision.some(b => a.DivisionName === b.divisionName));
            divisionIdsRemoved.map((a) => {
                removedDivisionId.push(a.divisionName)
            });
        }

        if (selectedValue.groupName) {
            selectedValue.groupName.map((a) => {
                groupDetails.push({
                    DivisionId: (a === "AllDivisions") ? 0 : a,
                })
            });
        }
        if (userId != null) {
            var groupRemoved = selectedGroup.filter(a => !groupDetails.some(b => a.divisionId === b.DivisionId));
            groupAdded = groupDetails.filter(a => !selectedGroup.some(b => a.DivisionId === b.divisionId));
            groupRemoved.map((a) => {
                removedGroupId.push(a.divisionId)
            });
        }
        if (userId != null) {
            selectedValue.UserGroup = groupAdded;
            selectedValue.UserDivision = addedDivisions;
        }
        else {
            selectedValue.UserGroup = groupDetails;
            selectedValue.UserDivision = divisionDetails;
        }
        selectedValue.GroupRemoved = removedGroupId;
        selectedValue.DivisionRemoved = removedDivisionId;
        selectedValue.IsActive = selectedValue.status === "active";

        this.setState({ isDisableSaveBtn: true }, () => {
            const url = `${ApiUrls.Routes.SECU_C}${ApiUrls.Routes.SV_USR_M}`;
            Api.Post(url, selectedValue, this).then((responseData) => {
                this.setState({ isDisableSaveBtn: false });
                if (responseData && userId == null) {
                    MessageBox(responseData.message, responseData.success ? Constants.SUCCESS : Constants.ERROR);
                } else if (responseData && userId != null && responseData.success) {
                    MessageBox(Constants.UPDATED_SUCCESSFULLY, Constants.SUCCESS);
                    if (this.props.user.userId == userId && this.props.user.roleId != selectedValue.securitygroupID) {
                        this.props.logout();
                    }
                } else {
                    MessageBox(responseData.message, responseData.success ? Constants.SUCCESS : Constants.ERROR);
                }
                if (responseData.success) {
                    this.onCloseModel();
                }
            });
        });
    }

    openDeactivateConfirmationPopup(userId) {
        this.setState({
            isDeActivateConfirmationModalVisible: true,
            activateOrDeactivateUserId: userId
        });
    }

    closeDeactivateConfirmationPopup() {
        this.setState({
            isDeActivateConfirmationModalVisible: false,
            activateOrDeactivateUserId: 0
        });
    }

    openActivateConfirmationPopup(userId) {
        this.setState({
            isActivateConfirmationModalVisible: true,
            activateOrDeactivateUserId: userId
        });
    }

    closeActivateConfirmationPopup() {
        this.setState({
            isActivateConfirmationModalVisible: false,
            activateOrDeactivateUserId: 0
        });
    }

    renderOptions() {
        return this.state.status.map((data, i) => {
            return (
                <MenuItem
                    label="Status"
                    value={data.value}
                    key={i} option={data.option}>{data.option}</MenuItem>

            );
        });
    }

    onActivateOrDeactivateUser(status) {
        let { activateOrDeactivateUserId } = this.state;
        let url = `${ApiUrls.Routes.SECU_C}${ApiUrls.Routes.ACTV_OR_DCTV_UR_M}?userId=${activateOrDeactivateUserId}&status=${status}`;
        Api.Post(url, null, this).then((responseData) => {
            MessageBox(responseData.message, responseData.success ? Constants.SUCCESS : Constants.ERROR);
            if (responseData.success) {
                this.closeActivateConfirmationPopup();
                this.closeDeactivateConfirmationPopup();
                this.getUserDetailsList();
            }
        });
    }

    render() {
        const { userDataList, status, userStatusOptions, selectedStatus, isActivateConfirmationModalVisible, isDeActivateConfirmationModalVisible, activateOrDeactivateUserId, filterSecurityData, isshowPasswordClick, isshowConfirmPassword, isEditUser, groupAccess, Division, selectedValue, existingUserDetails, group, selectedEmployeeFullName, selectedEmployeeNo, selectedGroup, isOpenModel, userData, pagination, securityEmployeeSearchText, securityUserNameSearchText, securityEmployeeNumberSearchText, securityGroupNameSearchText, isDisableSaveBtn } = this.state;
        return (
            <Fragment>
                <SecurityPageComponent
                    {...{
                        securityPage: {
                            userDataList,
                            filterSecurityData,
                            selectedEmployeeFullName,
                            selectedEmployeeNo,
                            selectedGroup,
                            isOpenModel,
                            userData,
                            pagination,
                            groupAccess,
                            Division,
                            group,
                            selectedValue,
                            existingUserDetails,
                            isEditUser,
                            isshowPasswordClick,
                            isshowConfirmPassword,
                            status,
                            userStatusOptions,
                            selectedStatus,
                            isActivateConfirmationModalVisible,
                            isDeActivateConfirmationModalVisible,
                            activateOrDeactivateUserId,
                            securityEmployeeSearchText,
                            securityUserNameSearchText,
                            securityEmployeeNumberSearchText,
                            securityGroupNameSearchText,
                            isDisableSaveBtn
                        }
                    }}
                    onOpenModel={this.onOpenModel.bind(this)}
                    onCloseModel={this.onCloseModel.bind(this)}
                    handleFormChange={this.handleFormChange.bind(this)}
                    handleDivisionChange={this.handleDivisionChange.bind(this)}
                    handleGroupDivisionChange={this.handleGroupDivisionChange.bind(this)}
                    onSaveUser={this.onSaveUser.bind(this)}
                    onUserNameSearch={this.onUserNameSearch.bind(this)}
                    onEmployeeNameSearch={this.onEmployeeNameSearch.bind(this)}
                    onEmployeeNumberSearch={this.onEmployeeNumberSearch.bind(this)}
                    onSecurityGroupSearch={this.onSecurityGroupSearch.bind(this)}
                    handleHideShowPassword={this.handleHideShowPassword.bind(this)}
                    handleHideShowConfirmPassword={this.handleHideShowConfirmPassword.bind(this)}
                    handleUserNameChange={this.handleUserNameChange.bind(this)}
                    handleEmployeeNumberChange={this.handleEmployeeNumberChange.bind(this)}
                    handleEmployeeNameChange={this.handleEmployeeNameChange.bind(this)}
                    handlePasswordChange={this.handlePasswordChange.bind(this)}
                    handleConfirmPasswordChange={this.handleConfirmPasswordChange.bind(this)}
                    onPageChange={this.onPageChange.bind(this)}
                    handleChange={this.handleChange.bind(this)}
                    renderOptions={this.renderOptions.bind(this)}
                    openActivateConfirmationPopup={this.openActivateConfirmationPopup.bind(this)}
                    closeActivateConfirmationPopup={this.closeActivateConfirmationPopup.bind(this)}
                    openDeactivateConfirmationPopup={this.openDeactivateConfirmationPopup.bind(this)}
                    closeDeactivateConfirmationPopup={this.closeDeactivateConfirmationPopup.bind(this)}
                    onActivateOrDeactivateUser={this.onActivateOrDeactivateUser.bind(this)}
                    user={this.props.user}
                />
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        Object.assign({},
            actions),
        dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SecurityPage));
SecurityPage.displayName = 'SecurityPage';